/** Client-side gate for integration API key management (mirrors RPC checks). */
export function canManageIntegrationKeys(
  p: (perm: string) => boolean
): boolean {
  return p('integrations.manage') || p('forms.embed')
}

export function canViewIntegrationKeys(p: (perm: string) => boolean): boolean {
  return (
    p('integrations.read') ||
    p('integrations.manage') ||
    p('forms.embed')
  )
}
